exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gestmensuelle td:nth-child(2) div.cell {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: inline-table;\n}\n.gestmensuelle .tooltip:hover {\n  cursor: pointer;\n}\n.error input {\n  border: 1px solid red!important;\n}\n", ""]);

// exports
